<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Icon, Text } from '@Shelly/shelly-design-system';

	export let showEditCta = false;

	const dispatch = createEventDispatcher();

	$: label = $format('label_add_additional_camera', {
		default: 'Add additional camera here',
	});

	function onEditClick(event: MouseEvent) {
		if (!showEditCta) return;
		event.stopPropagation();
		dispatch('edit');
	}
</script>

<button
	type="button"
	class="camera-placeholder"
	class:is-cta={showEditCta}
	disabled={!showEditCta}
	aria-label={label}
	on:click={onEditClick}
>
	<Icon icon="fal fa-video-plus" size="s" class="text-color-muted" />
	<Text styleType="body-extra-small" class="text-color-muted text-center">
		{label}
	</Text>
</button>

<style>
	.camera-placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: var(--spacing-xs);
		width: 100%;
		min-width: 0;
		height: 100%;
		aspect-ratio: 16 / 9;
		padding: var(--spacing-s);
		border: 1px dashed var(--color-border);
		border-radius: var(--radius-big);
		background: var(--color-0);
		box-sizing: border-box;
		color: inherit;
		font: inherit;
		cursor: default;
	}

	.camera-placeholder.is-cta {
		cursor: pointer;
	}

	.camera-placeholder:disabled {
		opacity: 1;
	}
</style>
